import { cx } from "./cx";
import type { ManualPage, View } from "./types";

export class QuoteWidgetRoot {
  static className(view: View | null, _page?: ManualPage): string {
    const entry = view !== null;
    const compact = view === null;
    return (
      cx("nv-quote-widget", "gf-theme", compact && "nv-quote-compact", entry && "nv-quote-entry") ??
      "nv-quote-widget gf-theme"
    );
  }
}
